import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function MenuSearchIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1Z" />
        <path d="M0 13C0 12.4477 0.447715 12 1 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H1C0.447715 14 0 13.5523 0 13Z" />
        <path d="M0 9C0 8.44772 0.447715 8 1 8H3C3.55228 8 4 8.44772 4 9C4 9.55228 3.55228 10 3 10H1C0.447715 10 0 9.55228 0 9Z" />
        <path d="M0 5C0 4.44772 0.447715 4 1 4H4C4.55228 4 5 4.44772 5 5C5 5.55228 4.55228 6 4 6H1C0.447715 6 0 5.55228 0 5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 12C7.79086 12 6 10.2091 6 8C6 5.79086 7.79086 4 10 4C12.2091 4 14 5.79086 14 8C14 10.2091 12.2091 12 10 12ZM10 6C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10C11.1046 10 12 9.10457 12 8C12 6.89543 11.1046 6 10 6Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 9.99999C12.3905 9.60947 13.0237 9.60947 13.4142 9.99999L15.7071 12.2929C16.0976 12.6834 16.0976 13.3166 15.7071 13.7071C15.3166 14.0976 14.6834 14.0976 14.2929 13.7071L12 11.4142C11.6095 11.0237 11.6095 10.3905 12 9.99999Z"
        />
      </svg>
    </Icon>
  );
}
